const autoNgTemplateLoaderTemplate1 = require('./eventsDatatable.html');

angular.module('shbdeployer.docker').component('eventsDatatable', {
  templateUrl: autoNgTemplateLoaderTemplate1,
  controller: 'GenericDatatableController',
  bindings: {
    titleText: '@',
    titleIcon: '@',
    dataset: '<',
    tableKey: '@',
    orderBy: '@',
    reverseOrder: '<',
  },
});
